const actionType = {
    GET_SOURCE_RECORDS_SUCCESS: 'GET_SOURCE_RECORDS_SUCCESS',
    GET_SOURCE_RECORDS_FAILURE: 'GET_SOURCE_RECORDS_FAILURE',
    GET_ALL_SCHEMA_NAMES_SUCCESS: 'GET_ALL_SCHEMA_NAMES_SUCCESS',
    GET_ALL_SCHEMA_NAMES_FAILURE: 'GET_ALL_SCHEMA_NAMES_FAILURE',
    GET_RECON_GRAPH_SUMMARY: 'GET_RECON_GRAPH_SUMMARY',
    GET_TRADE_EXPLORER_RECORDS_SUCCESS: 'GET_TRADE_EXPLORER_RECORDS_SUCCESS',
    GET_TRADE_HISTORY_RECORDS_SUCCESS: 'GET_TRADE_HISTORY_RECORDS_SUCCESS',
    GET_CHILD_HISTORY_RECORDS_SUCCESS: 'GET_CHILD_HISTORY_RECORDS_SUCCESS',
    GET_SOURCE_RECORDS_SUCCESS_FROM_IMMNU_DB: 'GET_SOURCE_RECORDS_SUCCESS_FROM_IMMNU_DB',
};
export default actionType;
